AFRAME.registerComponent('drag-rotate-y', {
    schema: {
        target: { type: 'selector' },
        speed: { type: 'number', default: 2.0 } // Sensitivity for rotation
    },

    init: function () {
        this.dragging = false;
        this.raycasterEl = null;
        this.initialControllerPos = new THREE.Vector3();
        this.initialTargetRotationY = 0;
        this.isMouseDrag = false;
        this.startMouse = { x: 0, y: 0 };
        this.currentMouse = { x: 0, y: 0 };

        this.onWindowMouseMove = this.onWindowMouseMove.bind(this);
        window.addEventListener('mousemove', this.onWindowMouseMove);

        this.el.addEventListener('raycaster-intersected', e => {
            this.raycasterEl = e.detail.el;
        });

        this.el.addEventListener('raycaster-intersected-cleared', e => {
            if (!this.dragging) {
                this.raycasterEl = null;
            }
        });

        this.el.addEventListener('triggerdown', () => {
            this.isMouseDrag = false;
            this.startDrag();
        });
        this.el.addEventListener('triggerup', () => this.stopDrag());

        this.el.addEventListener('mousedown', (e) => {
            this.isMouseDrag = !window.AppState || !window.AppState.isTrueVRMode;
            this.startDrag();
        });
        window.addEventListener('mouseup', () => this.stopDrag());

        const parsed = getCacheItem('mainSettings');
        this.autoRotatePanels = parsed?.autoRotatePanels !== false;
        console.log('autoRotatePanels', this.autoRotatePanels)
        this.el.sceneEl.addEventListener('rotate-panels-mode-changed', this.updateRotationMode.bind(this));
    },

    remove: function () {
        window.removeEventListener('mousemove', this.onWindowMouseMove);
    },

    onWindowMouseMove: function (e) {
        this.currentMouse.x = e.clientX;
        this.currentMouse.y = e.clientY;
    },

    getControllerPosition: function () {
        if (!this.raycasterEl) return null;

        const controllerPos = new THREE.Vector3();
        this.raycasterEl.object3D.getWorldPosition(controllerPos);
        return controllerPos;
    },

    startDrag: function () {
        if (this.autoRotatePanels) return;
        if (!this.raycasterEl && !this.isMouseDrag) return;

        this.dragging = true;

        if (this.isMouseDrag) {
            this.startMouse.x = this.currentMouse.x;
            this.startMouse.y = this.currentMouse.y;
            this.el.sceneEl.emit('drag-move-start');
        } else {
            const controllerPos = this.getControllerPosition();
            if (!controllerPos) return;
            this.initialControllerPos.copy(controllerPos);
        }
        if (!this.data.target || !this.data.target.object3D) return;
        this.initialTargetRotationY = this.data.target.object3D.rotation.y;
    },

    stopDrag: function () {
        if (this.autoRotatePanels) return;
        if (this.dragging && this.isMouseDrag) {
            this.el.sceneEl.emit('drag-move-end');
        }
        this.dragging = false;

        if (this.raycasterEl) {
            const intersection = this.raycasterEl.components.raycaster.getIntersection(this.el);
            if (!intersection) {
                this.raycasterEl = null;
            }
        }
    },

    tick: function () {
        if (!this.dragging) return;
        if (!this.data.target || !this.data.target.object3D) return;

        let deltaRotation = 0;

        if (this.isMouseDrag) {
            const sensitivity = 0.005 * this.data.speed;
            const deltaX = (this.currentMouse.x - this.startMouse.x);
            deltaRotation = deltaX * sensitivity;

        } else {
            if (!this.raycasterEl) return;

            const currentControllerPos = this.getControllerPosition();
            if (!currentControllerPos) return;

            const deltaWorld = new THREE.Vector3().subVectors(currentControllerPos, this.initialControllerPos);

            const camera = this.el.sceneEl.camera;
            if (camera) {
                const cameraRight = new THREE.Vector3(1, 0, 0).applyQuaternion(camera.quaternion);
                cameraRight.y = 0;
                cameraRight.normalize();

                const movementRight = deltaWorld.dot(cameraRight);

                deltaRotation = movementRight * 12 * this.data.speed;
            } else {
                deltaRotation = deltaWorld.x * 12 * this.data.speed;
            }
        }

        this.data.target.object3D.rotation.y = this.initialTargetRotationY + deltaRotation;

        const rotDegY = this.data.target.object3D.rotation.y * 180 / Math.PI;
        const rotDegX = this.data.target.object3D.rotation.x * 180 / Math.PI;
        const rotDegZ = this.data.target.object3D.rotation.z * 180 / Math.PI;
        const rotationValues = { x: rotDegX, y: rotDegY, z: rotDegZ };
        this.data.target.emit('update-rotation', rotationValues);
        this.el.sceneEl.emit('update-rotation', rotationValues);
    },

    updateRotationMode: function (e) {
        console.log('updateRotationMode', e)
        if (!e || !e.detail) return;

        this.autoRotatePanels = e.detail.autoRotatePanels;
    }
});
